// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

export interface CustomerTypeModel {
    id: string;
    type: string;
    isRetailer: boolean;
    definition: string;
}

export interface AddAccountParameter extends ApiParameter {
    customerType: CustomerTypeModel;
    firstName: string;
    lastName: string;
    email: string;
    companyName: string;
    companyWebsite: string;
    shipToAddress1: string;
    shipToAddress2: string;
    shipToCity: string;
    shipToPostalCode: string;
    shipToState: string;
    shipToCountry: string;
    shipToPhoneNumber: string;
    preferredWholesalers: string[];
    businessShortDescription: string;
    numberOfOperatedStores: number;
    warehouseSquareFeet: number;
    hasLoadingDock: boolean;
    hasForklift: boolean;
    otherVendors: string;
    onSuccess?: (account?: AccountModel) => void;
    onError?: (error: string) => void;
}

const uri = "/api/synd/registration";

export const getCustomerTypes = async (): Promise<CustomerTypeModel[]> => {
    const result = await get<{ types: CustomerTypeModel[] }>(`${uri}/customer-types`);
    return result.types;
};

export const addAccount = async (parameters: AddAccountParameter): Promise<ServiceResult<any>> => {
    try {
        const result = await post(uri, parameters);
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
};
